import { InjectionToken } from '@angular/core';
import type { Capability } from '@sw-processes/api/session-management';
import type { Observable } from 'rxjs';
import type { INavigationItemValidator } from './navigation-item-validator.interface';
import type { PageTranslation } from './page-translation';

export interface NavigationItem<T> {
  key: string;
  label: PageTranslation;
  order?: number;
  enabled?: boolean;
  categoryKey?: string;
  validator?: INavigationItemValidator<T>;
  validatorArgs?: T;
  validatorEnum?: INavigationItemValidator<T>;
  validatorArgsEnum?: Array<Capability>;
  routeSegment?: string;
  popout?: boolean;
  badgeCounter$?: Observable<number>;
  action?: () => void;
}

// TODO: AW - fight for implementation
export const NAV_ITEM_TOKEN: InjectionToken<Array<NavigationItem<unknown>>> = new InjectionToken<Array<NavigationItem<unknown>>>(
  'NAV_ITEM_TOKEN'
);
